/*
  REAL YOU 搜尋
  完整商品編號、末七碼：搜尋商品說明。
  品牌、款式：商品名稱 AND 搜尋。
*/

const REALYOU_TITLE_SEARCH = {
  clean(value) {
    return String(value || '')
      .normalize('NFKC')
      .replace(/&amp;quot;|&quot;|&#34;/gi, '')
      .replace(/\b(?:title|body):/gi, '')
      .replace(/\s+AND\s+/g, ' ')
      .replace(/["*]/g, '')
      .trim();
  },

  code(value) {
    const text = this.clean(value)
      .replace(/^no\.?\s*[:：]?\s*/i, '')
      .replace(/[‐‑‒–—−]/g, '-')
      .replace(/\s*-\s*/g, '-');

    // 單獨輸入七位數字，例如 0630052。
    // 使用字串保留開頭的 0。
    if (/^\d{7}$/.test(text)) {
      return text;
    }

    // 完整編號，例如 B00-26Q2-0630052。
    if (/^[A-Z]\d{2}-\d{2}Q[1-4]-\d{7}$/i.test(text)) {
      return text.toUpperCase();
    }

    return null;
  },

  words(value) {
    return [
      ...new Set(
        this.clean(value)
          .replace(/[丨｜|]/g, ' ')
          .match(/[\p{L}\p{N}]+/gu) || []
      )
    ];
  },

  query(value) {
    const code = this.code(value);

    if (code) {
      return 'body:"' + code + '"';
    }

    const words = this.words(value);

    return words
      .map((word, index) => {
        const suffix = index === words.length - 1 ? '*' : '';
        return 'title:' + word + suffix;
      })
      .join(' AND ');
  },

  submit(event) {
    const form = event.currentTarget;
    const input = form.querySelector(
      'input[type="search"][name="q"]'
    );

    if (!input || form.getAttribute('role') !== 'search') {
      return;
    }

    event.preventDefault();

    const query = REALYOU_TITLE_SEARCH.query(input.value);

    if (!query) {
      input.focus();
      return;
    }

    const url = new URL(form.action, window.location.href);
    url.search = '';

    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('sort_by', 'price-ascending');

    const preview = new URL(
      window.location.href
    ).searchParams.get('preview_theme_id');

    if (preview) {
      url.searchParams.set('preview_theme_id', preview);
    }

    window.location.assign(url.toString());
  }
};

class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input || !this.input.form) {
      return;
    }

    const form = this.input.form;

    this.input.value = REALYOU_TITLE_SEARCH.clean(
      this.input.value
    );
    this.input.defaultValue = this.input.value;

    if (!form.dataset.ryTitleSearchReady) {
      form.dataset.ryTitleSearchReady = 'true';

      form.addEventListener(
        'submit',
        REALYOU_TITLE_SEARCH.submit
      );
    }

    form.addEventListener(
      'reset',
      this.onFormReset.bind(this)
    );

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.toggleResetButton();
  }

  toggleResetButton() {
    if (!this.input || !this.resetButton) {
      return;
    }

    this.resetButton.classList.toggle(
      'hidden',
      this.input.value.length === 0
    );
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();

    if (this.input && this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);